import { gql } from '@apollo/client';

export const ENGINE_ATTRIBUTES_QUERY = gql`
  query Query($pager: PagerInputNew, $filters: EngineAttributesFilterInput) {
    engineAttributes(pager: $pager, filters: $filters) {
      values {
        engineAttributeId
        attributeName
        description
        expression
        orderNo
        sensitiveInfo
        storeYN
      }
      total
    }
  }
`;

export const ENGINE_ATTRIBUTE_QUERY = gql`
  query engineAttribute($engineAttributeId: Int!) {
    engineAttribute(engineAttributeId: $engineAttributeId) {
      attributeName
      description
      engineAttributeId
      expression
      orderNo
      sensitiveInfo
      storeYN
    }
  }
`;

export const SCORING_GRIDS_QUERY = gql`
  query scoringGrids {
    scoringGrids {
      active
      code
      engineScoringId
      name
    }
  }
`;

export const ENGINE_ATTRIBUTES_FILTERS_QUERY = gql`
  {
    engineAttributeListFilters @client {
      fullTextFilter {
        value
      }
      name {
        value
      }
      description {
        value
      }
    }
  }
`;
